import {log} from "@dp-instant/utils";
import {Action} from "@dp-instant/core";
import {inject, injectable} from "inversify";
import {TypesGame} from "@game/TypesGame";
import {GameModel} from "@game/coregame/model/GameModel";
import {ISocial} from "@dp-instant/social";
import {Types2D, TypesSocial} from "@dp-instant/interfaces";
import {RootView} from "@dp-instant/2d";
import {Container, Graphics} from "pixi.js-legacy";
import {GenerateMapSpriteAction} from "@game/coregame/actions/GenerateMapSpriteAction";
import {ContinentModel} from "@game/coregame/model/ContinentModel";

@injectable()
export class TournamentCreateAction extends Action<any, boolean> {
    static POST_WIDTH = 680;
    static POST_HEIGHT = 340;

    @inject(Types2D.rootView)
    protected readonly rootView: RootView;

    @inject(TypesGame.model)
    private readonly model: GameModel;

    @inject(TypesSocial.model)
    private readonly social: ISocial;

    @inject(TypesGame.actions.createMap)
    protected createMapAction: GenerateMapSpriteAction;

    async execute(): Promise<boolean> {
        if (this.social.socialPlatform !== "fb") {
            return false;
        }

        const continent = this.model.currentContinent;

        return await window.FBInstant.tournament
            .createAsync({
                initialScore: continent.getTotalScore(),
                data: continent.getHistory(),
                config: {
                    title: continent.data.id,
                    image: this.rootView.app.renderer.extract.base64(
                        await this.generateTournamentImage(this.model.currentContinent)
                    )
                }
            })
            .then(() => true)
            //@ts-ignore
            .catch(err => {
                log.warn("FBInstant.tournament.createAsync", err);
                return false;
            });
    }
    protected async generateTournamentImage(continent: ContinentModel) {
        const image = new Container();

        const bg = new Graphics()
            .beginFill(0xd0d0d0)
            .drawRect(0, 0, TournamentCreateAction.POST_WIDTH, TournamentCreateAction.POST_HEIGHT);
        image.addChild(bg);

        const map = await this.createMapAction.run({
            activeStage: continent.stageLevel,
            data: continent.data
        });
        const frameWidth = bg.width * 0.9;
        const frameHeight = bg.height * 0.9;
        const mapScale = this.aspectFactor(map.width, map.height, frameWidth, frameHeight);
        map.width *= mapScale;
        map.height *= mapScale;
        map.x = (bg.width - map.width) * 0.5;
        map.y = (bg.height - map.height) * 0.5;
        image.addChild(bg, map);

        return image;
    }
    protected aspectFactor(
        innerWidth: number,
        innerHeight: number,
        outerWidth: number,
        outerHeight: number
    ): number {
        const inner = innerWidth / innerHeight;
        const outer = outerWidth / outerHeight;
        return inner >= outer ? outerWidth / innerWidth : outerHeight / innerHeight;
    }
}
